module.exports = __webpack_public_path__ + "media/src/components/InsuranceProduct/car-insurance-3589fb727b6547e467fd0485ea210b3a.png";